const extractOrder = sort => {
  if (sort.order === "descend") {
    return `-${sort.field}`;
  }
  return sort.field;
};

export default extractOrder;
